import { DatePicker } from "@admin-ui/components/application/date-picker/date-picker";
import { Input } from "@admin-ui/components/primitives/base/input/input";
import { type DateValue, parseDate } from "@internationalized/date";

/** Convert an ISO date string (YYYY-MM-DD) to a DateValue, or null. */
export function parseDateValue(iso: string | null): DateValue | null {
  if (!iso) return null;
  try {
    return parseDate(iso);
  } catch {
    return null;
  }
}

interface PersonFormFieldsProps {
  name: string;
  onNameChange: (value: string) => void;
  dateOfBirth: DateValue | null;
  onDateOfBirthChange: (value: DateValue | null) => void;
}

export function PersonFormFields({ name, onNameChange, dateOfBirth, onDateOfBirthChange }: PersonFormFieldsProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <p className="text-sm font-medium text-secondary">
          Name <span className="text-error">*</span>
        </p>
        <Input size="sm" placeholder="Full name" value={name} onChange={onNameChange} isRequired />
      </div>
      <div className="flex flex-col gap-1.5">
        <p className="text-sm font-medium text-secondary">Date of birth</p>
        <DatePicker value={dateOfBirth} onChange={onDateOfBirthChange} />
      </div>
    </div>
  );
}
